module.exports = __webpack_public_path__ + "static/media/Car-Removal-Services-in-Logan.ef7e0573.jpg";